import React, { useEffect, useState } from 'react';
import styles from './index.module.scss'
import { ApiCore } from '../../../../../api/index';
import doctor_photo from '../../../../../static/images_pfizer/doctor_photo.png';
import health_tips from '../../../../../static/images_pfizer/health_tips.png';
import noTask from '../../../../../static/images_pfizer/noTask.png';
import moment from 'moment';
const api = new ApiCore();


const Home = (props: any) => {

    const [infoData, setInfoData] = useState<any>(null)
    const [healthTips, setHealthTips] = useState<any>('')
    const [taskList, setTaskList] = useState<any>([])

    const [activeTab, setActiveTab] = useState<any>('1')

    useEffect(() => {
        window.document.title = '首页'
        getPatientCaseInfo()
        getTaskListToday()
    }, [])


    const getPatientCaseInfo = () => {
        api.getPatientCaseInfo().then((res: any) => {
            if (res.code == 0) {
                setInfoData(res.data)
                getGroupHealthTip(res.data.groupCode)
            }
        })
    }

    const getGroupHealthTip = (groupCode: any) => {
        let params = {
            groupCode
        }
        api.getGroupHealthTip(params).then((res: any) => {
            if (res.code == 0) {
                setHealthTips(res.data.content)
            }
        })
    }


    const changeTab = (active: any) => {
        setActiveTab(active)
        if (active == '0') {
            getTaskListComplete()
        } else if (active == '1') {
            getTaskListToday()
        } else if (active == '2') {
            getTaskListTomorrow()
        }
    }

    //获取患者已完成任务
    const getTaskListComplete = () => {
        api.getPatientTaskListComplete().then((res: any) => {
            if (res.code == 0) {
                setTaskList(res.data)
            }
        })
    }

    //获取患者今日任务
    const getTaskListToday = () => {
        api.getPatientTaskListToday().then((res: any) => {
            if (res.code == 0) {
                setTaskList(res.data)
            }
        })
    }

    //获取患者明日计划
    const getTaskListTomorrow = () => {
        api.getPatientTaskListTomorrow().then((res: any) => {
            if (res.code == 0) {
                setTaskList(res.data)
            }
        })
    }


    const formatDate = (data: any) => {
        if (data.startTime && data.endTime) {
            let startTime = moment(new Date(data.startTime)).format('YYYY.MM.DD')
            let endTime = moment(new Date(data.endTime)).format('MM.DD')
            return startTime + '-' + endTime
        }
    }

    const renderTaskDom = (v: any, i?: number) => {
        let dom: any
        if (v.type == 'clinic') {
            dom = <div className={`${styles.task} ${styles.Outpatient}`} key={i}>
                <div className={styles.taskName}>随访门诊提醒</div>
                <div className={styles.taskInfo}>{v.name}</div>
                {v.startTime && <div className={styles.taskInfo}>门诊时间：{formatDate(v)}</div>}
            </div>
        } else if (v.type == 'datacapture') {
            dom = <div className={`${styles.task} ${styles.questionnaire}`} key={i}>
                <div className={styles.taskName}>随访线上问卷提醒</div>
                <div className={styles.taskInfo}>
                    <span>{v.name}</span>
                    {v.state == 1 && <span className={styles.status}>待填写</span>}
                </div>
                {v.startTime && <div className={styles.taskInfo}>门诊时间：{formatDate(v)}</div>}
            </div>
        } else if (v.type == 'article') {
            dom = <div className={`${styles.task} ${styles.Preach}`} key={i}>
                <div className={styles.taskName}>随访宣教</div>
                <div className={styles.taskInfo}>
                    <span>{v.name}</span>
                    {v.state == 1 && <span className={styles.status}>待阅读</span>}
                </div>
            </div>
        } else if (v.type == 'AE') {
            dom = <div className={`${styles.task} ${styles.AE}`}>
                <div className={styles.taskName}>AE上报提醒 <span>（选填）</span></div>
                <div className={styles.taskInfo}>若您在随访用药期间身体出现了一些不良反应，您可以在此上报您的症状。</div>
            </div>
        }

        return dom
    }


    return (
        <div className={styles.home_content}>
            <div className={styles.pName}>{infoData && infoData.groupName}</div>
            <div className={styles.time}>我的抗癌第 <span className={styles.number}>{infoData && infoData.joinTimeNum}</span> 天 </div>
            <div className={styles.tips}>
                <img src={health_tips} alt="" />
                <div className={styles.tipContent}>
                    <div>每日健康Tips</div>
                    <div className={styles.tipText}>{healthTips}</div>
                </div>
            </div>

            <div className={styles.doctorInfo}>
                <img className={styles.avatar} src={doctor_photo} alt="" />
                <div className={styles.info}>
                    <div className={styles.doctorName}>{infoData && infoData.doctorName}</div>
                    <div className={styles.tip1}>{infoData && infoData.jobTitle} {infoData && infoData.dept}</div>
                    <div className={styles.tip2}>{infoData && infoData.hospital}</div>
                </div>
            </div>

            <div className={styles.task_tabs}>
                <div className={activeTab == '0' ? `${styles.task_tab} ${styles.active}` : styles.task_tab} onClick={() => changeTab('0')}>过去完成</div>
                <div className={activeTab == '1' ? `${styles.task_tab} ${styles.active}` : styles.task_tab} onClick={() => changeTab('1')}>今日任务</div>
                <div className={activeTab == '2' ? `${styles.task_tab} ${styles.active}` : styles.task_tab} onClick={() => changeTab('2')}>明天计划</div>
            </div>
            <div className={styles.taskList}>
                {
                    taskList.length > 0 ? <>
                        {taskList.map((item: any, index: number) => (
                            renderTaskDom(item, index)
                        ))}
                        {
                            activeTab == '1' && renderTaskDom({ type: 'AE' })
                        }
                    </> : <>
                        {activeTab == '1' ? <>
                            {
                                renderTaskDom({ type: 'AE' })
                            }
                        </> :
                            <div className={styles.noTaskContent}>
                                <img src={noTask} alt="" />
                                <div>暂无任务</div>
                            </div>}
                    </>
                }
            </div>
        </div>
    )

}

export default Home
